'use strict';

exports.__esModule = true;

var _utils = require('../utils');

var _normal = require('../fetcher/normal');

var _normal2 = _interopRequireDefault(_normal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports['default'] = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx, next) {
        var _ctx$req, originUrl, dataType, resOptions, response, status, statusText, ok, resHeaders, body;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!(!_utils.isWeb || _utils.isWeb && ctx.req.type !== 'normal')) {
                            _context.next = 4;
                            break;
                        }

                        _context.next = 3;
                        return next();

                    case 3:
                        return _context.abrupt('return', _context.sent);

                    case 4:
                        _ctx$req = ctx.req, originUrl = _ctx$req.originUrl, dataType = _ctx$req.dataType;
                        resOptions = {
                            status: 408,
                            statusText: 'Request Timeout',
                            ok: false,
                            headers: new Headers(),
                            body: 'Request to ' + originUrl + ' time out.'
                        };
                        _context.next = 8;
                        return (0, _normal2['default'])(ctx.req);

                    case 8:
                        response = _context.sent;

                        if (!response) {
                            _context.next = 31;
                            break;
                        }

                        status = response.status, statusText = response.statusText, ok = response.ok, resHeaders = response.headers;
                        body = null;

                        if (!(status >= 200 && status < 300)) {
                            _context.next = 27;
                            break;
                        }

                        _context.t0 = dataType;
                        _context.next = _context.t0 === 'json' ? 16 : _context.t0 === 'text' ? 20 : 24;
                        break;

                    case 16:
                        _context.next = 18;
                        return response.json();

                    case 18:
                        body = _context.sent;
                        return _context.abrupt('break', 25);

                    case 20:
                        _context.next = 22;
                        return response.text();

                    case 22:
                        body = _context.sent;
                        return _context.abrupt('break', 25);

                    case 24:
                        throw new TypeError('Not support data type: ' + dataType);

                    case 25:
                        _context.next = 30;
                        break;

                    case 27:
                        _context.next = 29;
                        return response.text();

                    case 29:
                        body = _context.sent;

                    case 30:
                        resOptions = {
                            status: status,
                            statusText: statusText,
                            ok: ok,
                            headers: resHeaders,
                            body: body
                        };

                    case 31:

                        ctx.generateResponse(resOptions);

                        _context.next = 34;
                        return next();

                    case 34:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function normalFetchMiddleware(_x, _x2) {
        return _ref.apply(this, arguments);
    }

    return normalFetchMiddleware;
}();

module.exports = exports['default'];